import { styleConstants } from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import SvgAlertCircledFilled from 'src/components/Svgs/SvgAlertCircledFilled'
import SvgLightningBolt from 'src/components/Svgs/SvgLightningBolt'
import { TagIconWithTooltip } from 'src/components/TagIconWithTooltip/TagIconWithTooltip'
import Trns from 'src/localization/Trns'
import { selectIsBetaOrgSuggestionsAndPredictions } from 'src/redux/selectors/data/organizations.selectors'
import { css, CSSProp } from 'styled-components'

export const ExpenseDetailsSourceIcon: React.FC<{
  errorMessage?: string
  cssProps?: CSSProp
  generatedByPrediction: boolean
}> = (props): React.ReactElement => {
  const enableSuggestions = useSelector(
    selectIsBetaOrgSuggestionsAndPredictions,
  )

  if (props.errorMessage) {
    return (
      <TagIconWithTooltip
        cssProps={props.cssProps}
        testId={'automationRuleConflictTag'}
        iconBackgroundColor={styleConstants.colors.yellow_background_light}
        icon={
          <SvgAlertCircledFilled
            css={css`
              width: 16px;
              height: 16px;
              transform: scale(0.68);
              transform-origin: top left;
              overflow: visible;
            `}
            fill={styleConstants.colors.yellow_darkest}
          />
        }
        tooltipText={
          <Trns
            source={
              'There was a conflict applying rules to this transaction. Double-check the expense categories applied.'
            }
          />
        }
      />
    )
  } else if (props.generatedByPrediction && enableSuggestions) {
    return (
      <TagIconWithTooltip
        cssProps={props.cssProps}
        testId={'automationRulePredictionTag'}
        iconBackgroundColor={styleConstants.colors.purple_light}
        icon={<SvgLightningBolt fill={styleConstants.colors.purple_dark} />}
        borderWidth={1}
        tooltipText={
          <Trns
            source={'This category was predicted based on past transactions'}
          />
        }
      />
    )
  } else {
    return (
      <TagIconWithTooltip
        cssProps={props.cssProps}
        testId={'automationRuleAppliedTag'}
        iconBackgroundColor={styleConstants.colors.purple_light}
        icon={<SvgLightningBolt fill={styleConstants.colors.purple_dark} />}
        tooltipText={
          <Trns
            source={'This category has been automatically tagged for you'}
          />
        }
      />
    )
  }
}
